// extracted by mini-css-extract-plugin
export default {"modelContainer":"IFrameModal_modelContainer__ul4rG","iframe":"IFrameModal_iframe__I6Udw"};